var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      attrs: {
        top: "",
        vertical: "",
        "multi-line": "",
        timeout: _vm.timeout,
        color: "error",
      },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function (ref) {
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                {
                  attrs: { dark: "", text: "" },
                  on: { click: _vm.closeClicked },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.btnTextClose) + "\n        "
                  ),
                ]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [_c("span", { domProps: { innerHTML: _vm._s(_vm.message) } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }